module.exports = __webpack_public_path__ + "img/clock.8f6c1070.svg";